import { render, staticRenderFns } from "./article18.vue?vue&type=template&id=690816b2&scoped=true"
import script from "./article18.vue?vue&type=script&lang=js"
export * from "./article18.vue?vue&type=script&lang=js"
import style0 from "./article18.vue?vue&type=style&index=0&id=690816b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690816b2",
  null
  
)

export default component.exports